import React from 'react';
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
export function Business() {
  return (
    <div className="business">
      <PageHeader />
      <DataBox />
    </div>
  );
}


